import { format, isValid, parse } from "date-fns";

export const isValidDate = (date: string, formatStr: string = "dd-MM-yyyy") => {
    const parsedDate = parse(date, formatStr, new Date());
    return !(isValid(parsedDate) && format(parsedDate, formatStr) === date);
};

export const formatDate = (date: Date, formatType = "dd-MM-yyyy") => {
    return format(date, formatType)
};

export const isValidEmail = (email: string): boolean => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
};

export const isValidPhone = (phone: string): boolean => {
    const phoneRegex = /^[6-9]\d{9}$/;
    return phoneRegex.test(phone);
};

export const isValidPassword = (password: string): boolean => {
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    return passwordRegex.test(password);
};

export const formatToDDMMYYYY = (date: string | null) => {
    if (!date) return undefined;
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
};
